import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { getMindfile } from '../../../../state/actions/getDataActions'
import { addFriend, removeFriend } from './../../../../state/actions/updateDataActions'
import Box from '@material-ui/core/Box'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import VisibilityIcon from '@mui/icons-material/Visibility'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { API_ROOT } from '../../../../baseUrls'
import CheckIcon from '@mui/icons-material/Check'
import {formatLocation, formatStyles} from "../../../../helpers/FormatUtils";

const styles = {
  ...formatStyles,
  iconTextBlock: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  iconText: {
    marginLeft: 8,
  }
}

class SearchResult extends Component {
  changeMindfile(mid) {
    return () => {
      this.props.getMindfile(mid)
      this.props.history.push('/explore')
    }
  }

  addFriend(user) {
    return() => {
      this.props.addFriend(user)

      fetch(`${ API_ROOT }/mindfiles/${this.props.mindfile.id}/befriend/${user.id}`, {
        method: 'GET',
        credentials: 'include',
      })
      .then((resp) => {
        resp.json().then((result) => {
          this.props.refresh()
          if (result[0].status === 'error' && result[0].messsage !== 'Already friends') {
            this.props.removeFriend(user)
          }
          this.setState({ result })
        })
        .catch((error) => {
          this.props.removeFriend(user)
          console.error(error)
        })
      })
      .catch((error) => {
        this.props.removeFriend(user)
        console.error(error)
      })
    }
  }

  render() {
    const { classes } = this.props
    const columns = [
      { id: 'name', label: 'Name' },
      { id: 'mindfileId', label: 'Mindfile', minWidth: 170 },
      { id: 'location', label: 'Location', minWidth: 100 },
      { id: 'add', label: 'Add', minWidth: 100, align: 'left' },
    ]

    const users = this.props.users.slice(0, 100)

    return(
      <Table>
        <TableHead>
          <TableRow>
            {columns.map(column => (
              <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody style={{backgroundColor: "#fff"}}>
          {users.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          }).map(user => {
            if (user) {
              return (
                <TableRow hover tabIndex={ -1 } key={ user.bot_name }>
                  <TableCell>{ user.name }</TableCell>
                  <TableCell><Box className={ classes.iconTextBlock } onClick={ this.changeMindfile(user.id).bind(this) }><VisibilityIcon /><span className={ classes.iconText }>View mindfile</span></Box></TableCell>
                  <TableCell>{ formatLocation(user.id, user.location, classes, {hideCoords: true}) }</TableCell>
                  <TableCell>
                    { user.friend ? <Box><CheckIcon/></Box> : <Box style={{ cursor: 'pointer' }} onClick={ this.addFriend(user).bind(this) }><AddCircleOutlineIcon/></Box> }
                  </TableCell>
                </TableRow>
              )
            }
            return null
          })}
        </TableBody>
      </Table>
    )
  }
}

const styledSearchResult = withStyles(styles)((withRouter(SearchResult)))

const mapStateToProps = (state) => {
  return {
    user: state.auth,
    mindfile: state.mindfile,
  }
};

const mapDispatchToProps = {
  getMindfile,
  addFriend,
  removeFriend,
};

export default connect(mapStateToProps, mapDispatchToProps)(styledSearchResult)
